/* tslint:disable */
import {
  Sector
} from '../index';

declare var Object: any;
export interface FundsAccountInterface {
  "name": string;
  "description"?: string;
  "id"?: number;
  "sector_id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  sector?: Sector;
}

export class FundsAccount implements FundsAccountInterface {
  "name": string;
  "description": string;
  "id": number;
  "sector_id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  sector: Sector;
  constructor(data?: FundsAccountInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `FundsAccount`.
   */
  public static getModelName() {
    return "FundsAccount";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of FundsAccount for dynamic purposes.
  **/
  public static factory(data: FundsAccountInterface): FundsAccount{
    return new FundsAccount(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'FundsAccount',
      plural: 'FundsAccounts',
      path: 'FundsAccounts',
      properties: {
        "name": {
          name: 'name',
          type: 'string'
        },
        "description": {
          name: 'description',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "sector_id": {
          name: 'sector_id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        sector: {
          name: 'sector',
          type: 'Sector',
          model: 'Sector'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/theme/services/sdk/models/FundsAccount.ts